import React, { FC } from 'react';
import { Typography, TypographyAppearanceVariants, TypographyTagVariants } from '@components/atoms/Typography';
import { Anchor, AnchorMode } from '@components/atoms/Anchor';
import { useHtmlTransformer } from '@hooks/useHtmlTransformer';

export interface SectionHeaderProps {
    overline?: string;
    title: {
        text: string;
        level?: TypographyAppearanceVariants.level2 | TypographyAppearanceVariants.level3;
    };
    description?: string;
    actionLabel?: string;
    linkTo?: string;
}

export const SectionHeader: FC<SectionHeaderProps> = ({ overline, title, description, actionLabel, linkTo }) => {
    const { transformHtml } = useHtmlTransformer();

    return (
        <div className={!description ? 'mb-4' : ''}>
            <div className="d-block d-md-flex align-items-end justify-content-between" data-testid="section-header">
                <div>
                    {overline && (
                        <Typography classes="mb-3" color="muted" fontSize="12" styles={{ spacedText: true }}>
                            {overline && transformHtml(overline)}
                        </Typography>
                    )}
                    <Typography
                        classes="mb-3 mb-md-0"
                        tagVariant={TypographyTagVariants.h2}
                        appearanceLevel={title.level || TypographyAppearanceVariants.level3}>
                        {title.text && transformHtml(title.text)}
                    </Typography>
                </div>
                {actionLabel && linkTo && (
                    <Anchor mode={AnchorMode.secondary} href={linkTo}>
                        {actionLabel}
                    </Anchor>
                )}
            </div>

            {description && (
                <Typography classes="mt-3" color="muted">
                    {description && transformHtml(description)}
                </Typography>
            )}
        </div>
    );
};
